import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, Col, Row} from 'antd';
import maintenanceIcon from '../img/cuiIcons/maintenance.png';
import tiresIcon from '../img/cuiIcons/tires_icon.png';
import './HomeScreen.css';
import {isBigEnough} from './journey1/helper/uiHelper';
import {MAINTENANCE, TIRES} from './journey1/definition/business';
import {withRouter} from 'react-router-dom';


class StartJourneyButtons extends Component {

  goToJourney = () => {
    this.props.history.push('/public/journey');
  };

  renderAppointmentOptions = (label, icon, imgAlt, type) => (
    <Card
      className="hoverable"
      bordered
      onClick={()=>this.onMaintenanceRepairPressedClosure(type)}
    >
      <Row type="flex" gutter={16}>
        <Col span={8}>
          <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <img
              style={{ maxHeight: '70px', marginLeft: 'auto', marginRight: 'auto' }}
              src={icon}
              alt={imgAlt}
            />
          </div>
        </Col>
        <Col span={16} style={{ margin: 'auto' }}>
          <h2 style={{ fontSize: 20, fontWeight: 'bold', margin: 'auto' }}>{label}</h2>
        </Col>
      </Row>
    </Card>
  );

  onMaintenanceRepairPressedClosure = (type) => {
    const { selectedDealer, selectedVIN, selectedVehicle,publicContext } = this.props;
    if (selectedDealer) {
      this.props.dispatchFetchPreJourneyInfo({
        dealerId: selectedDealer.id,
        untrustedVin: selectedVIN ? selectedVIN.vin : null,
        callback: this.goToJourney,
        vin: selectedVIN ? selectedVIN.vin : selectedVehicle.vin,
        bookingToken:publicContext.bookingToken,
        type,
      });
    }
  };

  render() {
    const {intl: { formatMessage }, sizeClass, publicContext} = this.props;

    return <Row gutter={16} style={{marginBottom: 30}}>
      <Col
        span={12}
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        xxl={24}
        style={{marginBottom: isBigEnough(sizeClass) ? 0 : 30}}
      >
        {this.renderAppointmentOptions(
          formatMessage({id: 'customer.home.appointmentType.appointment'}),
          maintenanceIcon,
          formatMessage({id: 'customer.home.appointmentType.appointment'}),
          MAINTENANCE
        )}
      </Col>
      <Col span={12} xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
        {!publicContext.bookingToken && this.renderAppointmentOptions(
          formatMessage({id: 'customer.home.tiresWheels'}),
          tiresIcon,
          formatMessage({id: 'customer.home.tiresWheels'}),
          TIRES
        )}
      </Col>
    </Row>
  };
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchPreJourneyInfo: params =>
    dispatch({ type: 'FETCH.PRE_JOURNEY_INFORMATION.REQUEST', params }),
});

const mapStateToProps = state => ({
  selectedDealer: state.customerDealer.selectedDealer,
  selectedVehicle: state.customerVehicle.selectedVehicle,
  selectedVIN: state.customerVehicle.selectedVIN,
  customerPreJourneyInfo: state.customerPreJourneyInfo.preJourneyInfo,
  customerPreJourneyInfoLoading: state.customerPreJourneyInfo.loading,
  publicContext: state.publicContext,
});

export default withRouter(injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StartJourneyButtons)
));
